import { createAsyncThunk } from "@reduxjs/toolkit";
import ProductOptionsAPI, { ProductOption } from "../../../api/ProductOptions";
import TenantOptionsAPI from "../../../api/TenantOptions";
import UsersAPI, { User, UserRole } from "../../../api/Users";
import { OptionValues } from "../../../api/common";
import FeatureFlagsAPI, { TenantFeatureFlag } from "../../../../src/api/featureFlag";
import { fetchStageConfigs } from "../../caseStages/logic/thunks";

export const fetchAllConfigs = createAsyncThunk<void, void>(
  "configs/fetchAll",
  async (_, { dispatch }) => {
    dispatch(fetchTenantOptions());
    dispatch(fetchProductOptions());
    dispatch(fetchFeatureFlags());
    dispatch(fetchUsersByRoles());
    dispatch(fetchStageConfigs());
  }
);

export const fetchTenantOptions = createAsyncThunk<OptionValues[], void>(
  "configs/fetchTenantOptions",
  async () => {
    return await TenantOptionsAPI.get();
  }
);

export const fetchProductOptions = createAsyncThunk<ProductOption[], void>(
  "configs/fetchProductOptions",
  async () => {
    return await ProductOptionsAPI.get();
  }
);

export const fetchInvestigators = createAsyncThunk<User[], void>(
  "configs/fetchInvestigators",
  async () => {
    return await UsersAPI.get_users_with_roles([UserRole.INVESTIGATOR]);
  }
);

export const fetchSupervisingAuthorities = createAsyncThunk<User[], void>(
  "configs/fetchSupervisingAuthorities",
  async () => {
    return await UsersAPI.get_users_with_roles([UserRole.SUPERVISING_AUTH_L1, UserRole.SUPERVISING_AUTH_L2]);
  }
);

export const fetchCollaborators = createAsyncThunk<User[], void>(
  "configs/fetchCollaborators",
  async () => {
    return await UsersAPI.get_users_with_roles([UserRole.COLLABORATOR]);
  }
);

export const fetchFeatureFlags = createAsyncThunk<TenantFeatureFlag[], void>(
  "configs/fetchFeatureFlags",
  async () => {
    return await FeatureFlagsAPI.get();
  }
);

export const fetchUsersByRoles = createAsyncThunk<User[], void>(
  "users/fetchUsersByRoles",
  async () => {
    return await UsersAPI.get_users_with_roles([
      UserRole.INVESTIGATOR,
      UserRole.COLLABORATOR,
      UserRole.SUPERVISING_AUTH_L1,
      UserRole.SUPERVISING_AUTH_L2,
    ]);
  }
);